module.exports = __webpack_public_path__ + "static/media/list2.5974234c.svg";